import { DateTime } from 'luxon';
import { SabreTextLine } from './sabre-text-line';

export class SabreText {
  timestamp?: DateTime;
  raw: string;
  lines: SabreTextLine[];
  maxLength: number; // Longest line length in chars.

  constructor(text: string, timestamp: string) {
    this.timestamp = DateTime.fromISO(timestamp, { zone: 'utc' });
    this.raw = text;

    this.lines = text.split('\n').map((line) => {
      return { text: line };
    });

    let maxLength = 0;
    for (const line of this.lines) {
      if (line.text.length > maxLength) {
        maxLength = line.text.length;
      }
    }
    this.maxLength = maxLength;
  }
}
